import React from 'react';
import { Modal, Button } from 'antd';
import WarnIcon from '@web-common/components/UI/Icons/svgs/WarnSvg';
import { ModalCloseSmall } from '@web-common/components/UI/Icons/icons';
import { getIn18Text } from 'api';
const AttachmentBlockModal = ({ closeModal, visible, confirm }) => (React.createElement(Modal, { wrapClassName: "modal-dialog", onCancel: () => {
        closeModal();
    }, visible: visible, footer: null, closeIcon: React.createElement(ModalCloseSmall, null) },
    React.createElement("div", { className: "modal-content", style: { marginTop: '10px' } },
        React.createElement("div", { className: "modal-icon" },
            React.createElement(WarnIcon, null)),
        React.createElement("div", { className: "modal-text" },
            React.createElement("div", { className: "title" }, getIn18Text('FUJIANWEIWANCHENG')),
            React.createElement("div", { className: "btns" },
                React.createElement("div", null),
                React.createElement("div", null,
                    React.createElement(Button, { className: "cancel", onClick: () => {
                            closeModal();
                        } }, getIn18Text('QUXIAO')),
                    React.createElement(Button, { className: "save", onClick: () => {
                            confirm();
                        } }, getIn18Text('BAOCUN'))))))));
export default AttachmentBlockModal;
